
export type IconProps = {
    color?: string;
    size?: 'sm' | 'regular' | 'lg';
    width?: number;
    className?: string;
}

export type IconRotationProp = { rotationDeg?: number };

function IconSvgContainer(props: IconProps & { children: React.ReactNode } & IconRotationProp) {
    let size = undefined;

    if (props.size == 'sm') {
        size = 12;
    } else if (props.size == 'lg') {
        size = 32;
    } else if (props.size == 'regular') {
        size = 16;
    }

    if (props.width) {
        size = props.width;
    }

    const tr = props.rotationDeg ? `rotate(${props.rotationDeg}deg)` : '';

    return <span className={`inline-block shrink-0 ${props.className} [&>svg]:fill-current`} style={{ color: props.color, width: size, transform: tr }}>
        {props.children}
    </span>
}


export function IconSparkles(props: IconProps) {
    return <IconSvgContainer {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" />
        </svg>
    </IconSvgContainer>
}

export function IconThumbUp(props: IconProps) {
    return <IconSvgContainer {...props}>
        <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.2902 7.33341V12.6667C5.2902 12.8436 5.21996 13.0131 5.09494 13.1382C4.96992 13.2632 4.80035 13.3334 4.62354 13.3334H3.2902C3.11339 13.3334 2.94382 13.2632 2.8188 13.1382C2.69377 13.0131 2.62354 12.8436 2.62354 12.6667V8.00008C2.62354 7.82327 2.69377 7.6537 2.8188 7.52868C2.94382 7.40365 3.11339 7.33341 3.2902 7.33341H5.2902ZM5.2902 7.33341C5.99745 7.33341 6.67572 7.05246 7.17582 6.55237C7.67592 6.05227 7.95687 5.37399 7.95687 4.66675V4.00008C7.95687 3.64646 8.09734 3.30732 8.34739 3.05727C8.59744 2.80722 8.93658 2.66675 9.2902 2.66675C9.64382 2.66675 9.98296 2.80722 10.233 3.05727C10.4831 3.30732 10.6235 3.64646 10.6235 4.00008V7.33341H12.6235C12.9772 7.33341 13.3163 7.47389 13.5663 7.72394C13.8164 7.97399 13.9569 8.31313 13.9569 8.66675L13.2902 12.0001C13.1943 12.4091 13.0124 12.7602 12.772 13.0007C12.5315 13.2412 12.2454 13.358 11.9569 13.3334H7.2902C6.75977 13.3334 6.25106 13.1227 5.87599 12.7476C5.50092 12.3726 5.2902 11.8638 5.2902 11.3334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconSvgContainer>
}

export function IconThumbDown(props: IconProps) {
    return <IconSvgContainer {...props}>
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.2902 8.66678V3.33345C5.2902 3.15664 5.21996 2.98707 5.09494 2.86205C4.96992 2.73702 4.80035 2.66678 4.62354 2.66678H3.2902C3.11339 2.66678 2.94382 2.73702 2.8188 2.86205C2.69377 2.98707 2.62354 3.15664 2.62354 3.33345V8.00012C2.62354 8.17693 2.69377 8.3465 2.8188 8.47152C2.94382 8.59655 3.11339 8.66678 3.2902 8.66678H5.2902ZM5.2902 8.66678C5.99745 8.66678 6.67572 8.94774 7.17582 9.44783C7.67592 9.94793 7.95687 10.6262 7.95687 11.3335V12.0001C7.95687 12.3537 8.09734 12.6929 8.34739 12.9429C8.59744 13.193 8.93658 13.3335 9.2902 13.3335C9.64382 13.3335 9.98296 13.193 10.233 12.9429C10.4831 12.6929 10.6235 12.3537 10.6235 12.0001V8.66678H12.6235C12.9772 8.66678 13.3163 8.52631 13.5663 8.27626C13.8164 8.02621 13.9569 7.68707 13.9569 7.33345L13.2902 4.00012C13.1943 3.59113 13.0124 3.23996 12.772 2.99947C12.5315 2.75899 12.2454 2.64224 11.9569 2.66678H7.2902C6.75977 2.66678 6.25106 2.8775 5.87599 3.25257C5.50092 3.62764 5.2902 4.13635 5.2902 4.66678" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconSvgContainer>
}


export function IconBack(props: IconProps) {
    return <IconSvgContainer {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"  ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M5 12l6 6" /><path d="M5 12l6 -6" /></svg>
    </IconSvgContainer>
}
